module.exports = __webpack_public_path__ + "img/logos_mastercard.84666959.svg";